import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { appTheme } from "./theme/theme";
import Cookies from "js-cookie"; // ✅ Import Cookies
import Login from "./pages/user/Login/index";
import PrivacyPolicy from "./pages/user/Privacy";
import Accept from "./pages/user/Accept/index";
import Home from "./pages/user/Home/index";
import LoginPage from "./pages/admin/Login";
import VerifyAdmin from "./pages/admin/Login/VerifyMobile";
import AdminPage from "./pages/admin/Home";
import ListPage from "./pages/admin/List";
import UsedPage from "./pages/admin/Used";
import DeletedPage from "./pages/admin/Delete";
import VerifyMobile from "./pages/user/Login/VerifyMobile";
import Campaign from "./pages/admin/Campaign";
import CampaignEntry from "./pages/user/CampaignEntry";
import VerifyMobileRegister from "./pages/user/Register/VerifyRegisterMobile";
import Logout from "./pages/user/Logout/index";
import AdminLogout from "./pages/admin/Logout/index";
import CompanyPage from "./pages/user/Comapany/index";
import CreateCoupon from "./pages/admin/CreateCoupon";
//import GoogleAnalytics from "./components/GoogleAnalytics/GoogleAnalytics";

// ✅ Create Protected Route for User
const UserProtectedRoute = ({ element: Element }) => {
    const userId = Cookies.get("user_id");
    const companyId = Cookies.get("company_id");
    return userId && companyId ? <Element /> : <Navigate to="/" />;
};

// ✅ Create Protected Route for Acceptance Page (allows state-based access for new registrations)
const AcceptanceRoute = ({ element: Element }) => {
    const userId = Cookies.get("user_id");
    const companyId = Cookies.get("company_id");
    
    // Allow access if cookies are set OR if coming from registration (will have state)
    // The Accept component will handle validation
    if (userId && companyId) {
        return <Element />;
    }
    
    // If no cookies, check if we're navigating from registration
    // This allows the Accept page to receive state and set cookies
    return <Element />;
};

// ✅ Create Protected Route for Admin
const AdminProtectedRoute = ({ element: Element }) => {
    const adminId = Cookies.get("admin_id");
    return adminId ? <Element /> : <Navigate to="/login" />;
};

// Protecting login pages (if already logged in)
const UserGuestRoute = ({ element: Element }) => {
    const userId = Cookies.get("user_id");
    const companyId = Cookies.get("company_id");
    return userId && companyId ? <Navigate to="/user_home" state={{ company_id: companyId }} /> : <Element />;
};

const AdminGuestRoute = ({ element: Element }) => {
    const adminId = Cookies.get("admin_id");
    const adminCompanyId = Cookies.get("admin_company_id");
    return adminId && adminCompanyId ? <Navigate to="/admin" state={{ admin_company_id: adminCompanyId }} /> : <Element />;
   
};


function App() {
    return (
        <ThemeProvider theme={appTheme}>
            <CssBaseline />
            <Router>
            {/* <GoogleAnalytics /> */}
            <Routes>
                 {/* user routes */}
                <Route path="/" element={<UserGuestRoute element={Login} />} />
                <Route path="/companies" element={<UserProtectedRoute element={CompanyPage} />} />
                <Route path="/logout" element={<UserProtectedRoute element={Logout} />} />
                <Route path="/verify-mobile" element={<VerifyMobile />} />
                <Route path="/verify-mobile-register" element={<VerifyMobileRegister />} />
                <Route path="/user_acceptance" element={<AcceptanceRoute element={Accept} />} />
                <Route path="/privacy_policy" element={<PrivacyPolicy />} />
                <Route path="/user_home" element={<UserProtectedRoute element={Home} />} />
                <Route path="/:campaignCode" element={<CampaignEntry />} />

                {/* admin routes */}
                <Route path="/login" element={<AdminGuestRoute element={LoginPage} />} />
                <Route path="/admin_logout" element={<AdminProtectedRoute element={AdminLogout} />} />
                <Route path="/verify-admin" element={<VerifyAdmin />} />
                <Route path="/admin" element={<AdminProtectedRoute element={AdminPage} />} />
                <Route path="/list" element={<AdminProtectedRoute element={ListPage} />} />
                <Route path="/delete" element={<AdminProtectedRoute element={DeletedPage} />} />
                <Route path="/used" element={<AdminProtectedRoute element={UsedPage} />} />
                <Route path="/add_campaign" element={<AdminProtectedRoute element={Campaign} />} />
                <Route path="/create_coupon" element={<AdminProtectedRoute element={CreateCoupon} />} />
                <Route path="*" element={<Navigate to="/login" />} />
            </Routes>

            </Router>
        </ThemeProvider>
    );
}

export default App;
